// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { InternalButton } from '../button/internal.js';
import { fireNonCancelableEvent } from '../internal/events/index.js';
import InternalLiveRegion from '../live-region/internal.js';
import Tooltip from '../tooltip/internal.js';
import testUtilStyles from './test-classes/styles.css.js';
const CopyToClipboardItem = forwardRef(({ item, showTooltip, showFeedback, onTooltipDismiss, onShowFeedback, onCopyFailure, onCopySuccess, }, ref) => {
    const containerRef = React.useRef(null);
    const [status, setStatus] = useState('success');
    const onClick = () => {
        const reportSuccess = () => {
            setStatus('success');
            onShowFeedback();
            fireNonCancelableEvent(onCopySuccess, { id: item.id, text: item.textToCopy });
        };
        const reportFailure = () => {
            setStatus('error');
            onShowFeedback();
            fireNonCancelableEvent(onCopyFailure, { id: item.id, text: item.textToCopy });
        };
        if (!navigator.clipboard) {
            reportFailure();
            return;
        }
        navigator.clipboard.writeText(item.textToCopy).then(reportSuccess, reportFailure);
    };
    const feedbackText = status === 'success' ? item.copySuccessText : item.copyErrorText;
    const canShowTooltip = Boolean(showTooltip && !item.disabled && !showFeedback);
    const canShowFeedback = Boolean(showTooltip && showFeedback && !item.disabled);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(InternalButton, { ref: ref, variant: "icon", iconName: "copy", ariaLabel: item.text, disabled: item.disabled, disabledReason: showFeedback ? undefined : item.disabledReason, __focusable: canShowFeedback, onClick: onClick, "data-testid": item.id, "data-itemid": item.id, className: clsx(testUtilStyles.item, testUtilStyles['button-group-item']), __title: "" }),
        (canShowTooltip || canShowFeedback) && (React.createElement(Tooltip, { className: testUtilStyles['button-group-tooltip'], getTrack: () => containerRef.current, content: (canShowFeedback && React.createElement(InternalLiveRegion, { tagName: "span" }, feedbackText)) || item.text, onEscape: onTooltipDismiss }))));
});
export default CopyToClipboardItem;
//# sourceMappingURL=copy-to-clipboard-item.js.map